import { Component, Injectable, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";
import { YoyakuService } from "../service/yoyaku.service";
import { ActivatedRoute, Router, RouterEvent, NavigationEnd, } from "@angular/router";
import { Location } from "@angular/common";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NgbInputDatepicker, NgbDatepickerI18n, NgbDateStruct, } from "@ng-bootstrap/ng-bootstrap";
import { UsersService } from "../service/users.service";
import { Role } from "../app.constant";
import { YoyakuConditionsEditModalComponent } from "./yoyaku-conditions-edit.component";
import { DayoftheweekSelecterModalComponent } from "./dayoftheweek-selecter.component";
import { AViewTextModalComponent } from "../a0106-mail/a-view-text-modal.component";
import { TimeaxisSelecterComponent } from "./timeaxis-selecter.component";
import { ShowYoyakuCreateriaComponent } from "./show-yoyaku-createria.component";

const I18N_VALUES = {
  ja: {
    weekdays: ["月", "火", "水", "木", "金", "土", "日"],
    months: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
  },
};

@Injectable()
export class I18n {
  language = "ja";
}
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n: I18n) {
    super();
  }
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
}
@Component({
  selector: "yoyaku-register-app",
  templateUrl: "./yoyaku-register.component.html",
  styleUrls: ["yoyaku-register.component.css"],
  providers: [I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})
export class YoyakuRegisterComponent implements OnInit {
  @Input() event_id: number;
  title: string = "";

  page: number = 1;
  all_count: number = 0;
  display_per_page: number = 20; /* 最大表示件数 */

  isLoaded: boolean = false;
  selected: boolean = false;
  selectedAtHistory: boolean = false;
  selectedTimeaxis: string = "";
  selectedDivisionId: string = null;
  yoyakuMaxCount: number = null;
  yoyakuMaxPoint: number = null;
  reply_date_start = null;
  reply_date_end = null;
  displayMonths = 2;
  TargetDayOfTheWeek: any = [
    { id: 0, name: "月曜日", enabled: false },
    { id: 1, name: "火曜日", enabled: false },
    { id: 2, name: "水曜日", enabled: false },
    { id: 3, name: "木曜日", enabled: false },
    { id: 4, name: "金曜日", enabled: false },
    { id: 5, name: "土曜日", enabled: false },
    { id: 6, name: "日曜日", enabled: false },
  ];
  selectedTargetDayOfTheWeek: string = "";
  selected_yoyaku_hyo_id: number = null;
  ROLE: any = Role;
  updYoyakuDataKeys: any = [
    "m_yoyaku_id",
    "m_division_1_id",
    "m_division_1_nm",
    "m_division_2_id",
    "m_division_2_nm",
    "start_time_definition",
    "end_time_definition",
    "max_yoyaku_count",
    "max_yoyaku_point",
    "conditions_group_kbn",
    "conditions_id",
    "sum_count",
    "sum_point",
    "yoyaku_memo",
    "display_memo",
    "invalid_flg",
  ];
  divisionList: any = [];
  timeaxisList: any = [];
  conditionsList: any = [];
  yoyakuhyoInfo: any = [];
  yoyakuDivisionList: any = [];
  yoyakuData: any = [];
  yoyakuDataAll: any = [];
  createContent: any = {
    timeaxisListId: null,
    timeaxisListName: null,
    divisionId: null,
    maxCount: null,
    maxPoint: null,
    conditionId: null,
    memo: null,
    targetDayOfTheWeekIds: null,
    replyDateStart: null,
    replyDateEnd: null,
  };
  createHistory: any = {};
  selectedTimeaxisIds: string = null;
  selectedTimeaxisNames: string = null;
  createDedabled : boolean = false;
  timeaxisListId : number = null;
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(
    private commonService: CommonService,
    public usersService: UsersService,
    private yoyakuService: YoyakuService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.selected_yoyaku_hyo_id = +this.route.snapshot.paramMap.get("yhid");
    this.getList();
    window.scrollTo(0, 0); //画面上部へ移動
  }
  clearData(): void {
    this.isLoaded = false;
    this.selected = false;
    this.clearTargetDayOfTheWeek();
  }
  getList(): void {
    this.clearData();
    this.getYoyakuCalenderList();
  }
  clearContent(): void {
    this.createContent.timeaxisListId = null;
    this.createContent.timeaxisListName = null;
    this.createContent.divisionId = null;
    this.createContent.maxCount = null;
    this.createContent.maxPoint = null;
    this.createContent.conditionId = null;
    this.createContent.memo = null;
    this.createContent.targetDayOfTheWeekIds = null;
    this.selectedTargetDayOfTheWeek = "";
    this.createContent.replyDateStart = null;
    this.createContent.replyDateEnd = null;
    this.selectedTimeaxisIds = null;
    this.selectedTimeaxisNames = null;
    for(let i in this.TargetDayOfTheWeek) {
      this.TargetDayOfTheWeek[i].enabled = false;
    }
    this.clearTargetDayOfTheWeek();
  }
  reload(): void {
    this.getList();
  }
  // 予約表情報の取得
  getYoyakuCalenderList(): void {
    let params = {
      t_yoyakuhyo_id: this.selected_yoyaku_hyo_id,
    };
    this.yoyakuService.getYoyakuAdminCalenderList(params).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.yoyakuhyoInfo = res["fuel_results"]["yoyakuhyo_info"];
          this.divisionList = res["fuel_results"]["division_list"];
          this.divisionList = this.divisionList.filter(
            (v: { disabled: number }) => v.disabled === 0
          );
          this.yoyakuDivisionList = res["fuel_results"]["yoyaku_division_list"];
          this.yoyakuDataAll = res["fuel_results"]["yoyaku_data"];
          this.all_count = res["fuel_results"]["yoyaku_count"];
          this.createHistory = res["fuel_results"]["create_yoyaku_history"];
          this.conditionsList = res["fuel_results"]["condition_list"];
          this.timeaxisList = res["fuel_results"]["timeaxis_list"];
          this.timeaxisList = this.timeaxisList.filter(
            (v: { disabled: number }) => v.disabled === 0
          );
          this.title = this.yoyakuhyoInfo[0].m_yoyakuhyo_content_nm;
          if (this.divisionList.length == 0 || this.timeaxisList.length == 0) {
            this.createDedabled = true;
          } else {
            this.createDedabled = false;
          }
          //一覧の区分選択状態
          if(this.selectedDivisionId==null　&& this.yoyakuDivisionList.length>0){
            this.selectedDivisionId = this.yoyakuDivisionList[0]['division_id'];
          }
          this.selectYoyakuData();
          this.isLoaded = true;
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {});
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }
  goYoyakuEdit(
    data: any,
    // index1: number,
    // index2: number,
    // index3: number
  ): void {
    const modalRef = this.modalService.open(
      YoyakuConditionsEditModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" } //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    // modalRef.componentInstance.yoyakuData = this.yoyakuData[index1].timeaxis_list[index2].yoyaku_data[index3];
    modalRef.componentInstance.yoyakuData = data;
    modalRef.componentInstance.conditionsList = this.conditionsList;
    modalRef.result.then(
      (result) => {
        if (result.status == "Update") {
          // this.yoyakuData[index1].timeaxis_list[index2].yoyaku_data[index3] =
          //   result.updYoyakuData;
          this.getList();
        } else if (result.status == "Delete") {
          // this.yoyakuData[index1].timeaxis_list[index2].yoyaku_data[index3] =
          //   result.updYoyakuData;
          this.getList();
        } else {
          //
        }
      },
      function () {
        //
      }
    );
  }
  goTargetDayOfTheWeekSelecter(): void {
    const modalRef = this.modalService.open(
      DayoftheweekSelecterModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "sm" } //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    modalRef.componentInstance.selected = this.TargetDayOfTheWeek;
    modalRef.result.then(
      (result) => {
        if (result.status == "OK") {
          this.TargetDayOfTheWeek = result.selectedData;
          this.clearTargetDayOfTheWeek();
        } else {
          //
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      }
    );
  }
  goTimeaxisSelecter(): void {
    const modalRef = this.modalService.open(
      TimeaxisSelecterComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" } //オプション設定　Esc,背景クリックの時の処理…停止中
    );
    modalRef.componentInstance.timeaxisList = this.timeaxisList;
    modalRef.componentInstance.selectedIds = this.selectedTimeaxisIds;
    modalRef.componentInstance.timeaxisListId = this.timeaxisListId;
    modalRef.result.then(
      (result) => {
        if (result.status == "OK") {
          this.selectedTimeaxisIds = result.result;
          this.selectedTimeaxisNames = result.resultNames;
          this.timeaxisListId = result.timeaxisListId;
        } else {
          //
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      }
    );
  }
  showerror(row): void {
    const modalRef = this.modalService.open(
      AViewTextModalComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }
    );
    let sendlisttext: string = "";
    modalRef.componentInstance.view_title = "エラー";
    modalRef.componentInstance.view_text = row.import_result;
    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      }
    );
  }
  showYoyakuCreateria(row): void {
    const modalRef = this.modalService.open(
      ShowYoyakuCreateriaComponent, //対象のComponent
      { backdrop: "static", keyboard: false, size: "lg" }
    );
    modalRef.componentInstance.selected = row;
    modalRef.componentInstance.DayOfTheWeek = this.TargetDayOfTheWeek;
    modalRef.result.then(
      (result) => {
        if (result.status == "Cancel") {
          //Cancel時の処理
        } else {
        }
      },
      function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
      }
    );
  }
  clearTargetDayOfTheWeek(): void {
    var item = this.TargetDayOfTheWeek.filter(
      (v: { enabled: boolean }) => v.enabled === true
    );
    var strWeeks = "";
    var ids = "";
    for (var i = 0; i < item.length; i++) {
      strWeeks = strWeeks + item[i].name.charAt(0);
      ids = ids + item[i].id;
      if (i + 1 != item.length) {
        strWeeks = strWeeks + ", ";
        ids = ids + ",";
      }
    }
    this.selectedTargetDayOfTheWeek = strWeeks;
    this.createContent.targetDayOfTheWeekIds = ids;
  }
  createYoyaku(): void {
    this.commonService.modalOpens(50019, (modalresult) => {
      if (modalresult == "OK") {
        let param = {
          id: null,
          m_yoyakuhyo_id: this.selected_yoyaku_hyo_id,
          m_timeaxis_ids: this.selectedTimeaxisIds,
          division_id: this.createContent.divisionId,
          max_count: this.createContent.maxCount,
          max_point: this.createContent.maxPoint,
          t_conditions_id: this.createContent.conditionId,
          invalid_flg: 0,
          Week_ids: this.createContent.targetDayOfTheWeekIds,
          yoyaku_memo: this.createContent.memo,
          yoyaku_date_start: this.createContent.replyDateStart,
          yoyaku_date_end: this.createContent.replyDateEnd,
        };
        this.yoyakuService.createYoyakuLump(param).subscribe(
          (res: Response) => {
            if (res["fuel_status"] == "OK") {
              this.commonService.modalOpens(10015, (modalresult) => {
                if (modalresult == "OK") {
                  this.clearContent();
                  this.selected = false;
                  this.selectedAtHistory = true;
                  this.createHistory =
                    res["fuel_results"]["create_yoyaku_history"];
                  this.timeaxisListId = null;
                }
              });
            } else if (res["fuel_status"] == "NG") {
              this.commonService.modalOpens(
                res["fuel_message"],
                (modalresult) => {}
              );
            } else {
              this.commonService.modalOpens(11003, (modalresult) => {});
            }
          },
          (error) => {
            this.commonService.modalOpens(error, (modalresult) => {});
          }
        );
      } else {
        //
      }
    });
  }
  cancel(mode: number): void {
    if (mode == 1) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.selected = false;
            this.clearContent();
          } else {
          }
        }
      );
    } else {
      this.selectedAtHistory = false;
    }
  }
  changeSelected(mode: number): void {
    if (this.selected == true) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.selected = false;
            this.selectedAtHistory = true;
          } else {
            //
          }
        }
      );
    } else if (this.selectedAtHistory == true) {
      this.selectedAtHistory = false;
      this.selected = true;
    } else if (mode == 1) {
      this.selected = true;
    } else {
      this.selectedAtHistory = true;
    }
  }
  checkList(): boolean {
    if (
      this.createContent.divisionId == null ||
      this.createContent.replyDateStart == null ||
      this.createContent.replyDateEnd == null ||
      this.selectedTimeaxisIds == null ||
      this.selectedTargetDayOfTheWeek == null ||
      this.selectedTargetDayOfTheWeek == "" 
    ) {
      return true;
    } else {
      if (this.checkDate(1)) {
        return true;
      } else if (this.checkNumber()){
        return true;
      } else {
        return false;
      }
    }
  }
  checkDate(mode: number): boolean {
    switch (mode) {
      //reply大小
      case 1:
        if (
          this.createContent.replyDateStart == null ||
          this.createContent.replyDateEnd == null
        ) {
          return false;
        } else {
          if (
            this.commonService.exchangeDateFormat2(
              this.createContent.replyDateStart
            ) >
            this.commonService.exchangeDateFormat2(
              this.createContent.replyDateEnd
            )
          ) {
            return true;
          } else {
            return false;
          }
        }
    }
  }
  checkNumber(): boolean {
    if(this.createContent.maxPoint == null){
      if(this.createContent.maxCount == null){
        return false;
      } else {
        let num2 = this.createContent.maxCount;
        let match2 = num2.match(/^[0-9]+$/);
        if(!match2) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      let num1 = this.createContent.maxPoint;
      let match1 = num1.match(/^[0-9]+$/);
      if(!match1) {
        return true;
      } else {
        return false;
      }
    }
  }
  replaceNumber(mode):void {
    if(mode == 1){
      if(this.createContent.maxCount == ""){
        this.createContent.maxCount = null;
      }
    } else {
      if(this.createContent.maxPoint == ""){
        this.createContent.maxPoint = null;
      }
    }
  }
  setConditionContent(id: any): void {
    this.createContent;
  }
  goBack(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.location.back();
          }
        }
      );
    } else {
      this.location.back();
    }
  }
  delYoyaku(row: any): void {
    this.commonService.modalOpens(50002, (modalresult) => {
      if (modalresult == "OK") {
        this.yoyakuService.deleteYoyakuLump(row).subscribe(
          (res: Response) => {
            if (res["fuel_status"] == "OK") {
              this.commonService.modalOpens(10002, (modalresult) => {
                if (modalresult == "OK") {
                  this.reload();
                }
              });
            } else if (res["fuel_status"] == "NG") {
              this.commonService.modalOpens(
                res["fuel_message"],
                (modalresult) => {}
              );
            } else {
              this.commonService.modalOpens(11003, (modalresult) => {});
            }
          },
          (error) => {
            this.commonService.modalOpens(error, (modalresult) => {});
          }
        );
      } else {
        //
      }
    });
  }
  selectYoyakuData(): void{
    this.yoyakuData = this.yoyakuDataAll.filter(
      (v: { division_id: string }) => v.division_id === this.selectedDivisionId
    );
  }
  goManintenance(): void {
    if (this.selected) {
      this.commonService.modalOpens(
        50005,
        //編集中の内容を破棄してもよろしいですか？
        (modalresult) => {
          if (modalresult == "OK") {
            this.router.navigate(["/yoyaku-maintenance"]);
          }
        }
      );
    } else {
      this.router.navigate(["/yoyaku-maintenance"]);
    }
  }
  /**
   * 切り替えるDatePicker以外を閉じながら、
   * toggleで表示非表示を切り替える
   *
   * @param selectDp 切り替えるDatePicker
   * @param subDp 閉じるDatePicker
   */
  toggleDate(selectDp: NgbInputDatepicker, subDp: NgbInputDatepicker): void {
    selectDp.toggle();
    subDp.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/a2103-yoyaku-register/yoyaku-register.component.ts